import type { HelpFile } from '../../types/help'
import { ConnectorConfigFormTestIds } from '../../../testids/ConnectorConfigFormTestIds'

export const connectorConfigFormHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorConfigFormTestIds.selectAuthType]: 'Authentication scheme the connector uses to talk to the target system — for example, basic auth, OAuth2 client credentials, or API key.',
    [ConnectorConfigFormTestIds.clientSecretRef]:
      'Reference to the OAuth2 client secret.',
    [ConnectorConfigFormTestIds.passwordSecretRef]:
      'Reference to the password secret for Basic authentication.',
    [ConnectorConfigFormTestIds.tokenSecretRef]:
      'Reference to the bearer token secret.',
  },
}
